// @ts-nocheck

import { WarningOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import AntInputNumber from 'antd/lib/input-number';
import { DatePicker as Datepicker } from '../../../components/ant/DatePicker';

import { GridItem, Section } from '../../../components/layout';

export const InspectionGridItem = styled(GridItem).withConfig({ displayName: "VerificationFormelements__InspectionGridItem", componentId: "sc-9sz5ry-0" })(["& > .field:last-child > .field__value{margin-bottom:0;}"]);




export const InspectionTitle = styled.p.withConfig({ displayName: "VerificationFormelements__InspectionTitle", componentId: "sc-9sz5ry-1" })(["color:#838d96;font-weight:500;margin-bottom:16px;"]);




export const InputNumber = styled(AntInputNumber).withConfig({ displayName: "VerificationFormelements__InputNumber", componentId: "sc-9sz5ry-2" })(["width:100%;"]);


export const DatePicker = styled(Datepicker).withConfig({ displayName: "VerificationFormelements__DatePicker", componentId: "sc-9sz5ry-3" })(["width:300px;"]);


export const SectionContent = styled.div.withConfig({ displayName: "VerificationFormelements__SectionContent", componentId: "sc-9sz5ry-4" })(["padding:16px;"]);



export const CarInfo = styled.div.withConfig({ displayName: "VerificationFormelements__CarInfo", componentId: "sc-9sz5ry-5" })(["padding:16px;background:#f0f4f8;& .field__value{margin-bottom:0;}"]);






export const WaypointsWrapper = styled(SectionContent).withConfig({ displayName: "VerificationFormelements__WaypointsWrapper", componentId: "sc-9sz5ry-6" })(["padding-top:0;"]);



export const FormFooter = styled(Section).withConfig({ displayName: "VerificationFormelements__FormFooter", componentId: "sc-9sz5ry-7" })(["padding:16px;display:flex;& > *{margin-right:16px;&:last-child{margin-right:0;}}"]);










export const FormTripMapWrapper = styled.div.withConfig({ displayName: "VerificationFormelements__FormTripMapWrapper", componentId: "sc-9sz5ry-8" })(["display:flex;flex-direction:row;justify-content:flex-start;align-items:center;p{padding-left:10px;}"]);









export const WarningIcon = styled(WarningOutlined).withConfig({ displayName: "VerificationFormelements__WarningIcon", componentId: "sc-9sz5ry-9" })(["cursor:help;color:#faad14;margin-left:8px;"]);





export const ButtonWrapper = styled.div.withConfig({ displayName: "VerificationFormelements__ButtonWrapper", componentId: "sc-9sz5ry-10" })(["display:flex;align-items:center;"]);